import cx from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

export interface ITabProps
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  active?: boolean;
}

export const Tab = ({ active, ...props }: ITabProps) => (
  <button {...props} className={cx(props.className, styles['tab'], active && styles['active'])} type="button" />
);
